(function(module) {
        'use strict';

        function SubAccountsCtrl($http, $mdDialog, $state, SubAccount, App, AppTemplate, Display, Group, Playlist, Integration, Includes, Store, envService) {
            this.$onInit = () => {

                // RESOLVE
                this.loading = true;
                this.account = Store.getCurrentAccount();
                this.SLS_URI = envService.read('SLS_URI');

                this.orderBy = 'id';
                this.selectedCount = 0;
                this.selectAllCheckbox = false;

                this
                    .getSubAccounts()
                    .then((response) => {
                        this.loading = false;
                        this.subAccounts = Store.setMultiModelData('subAccounts', response);
                    });
            };

            this.getSubAccounts = () => {
                return SubAccount
                    .find({ filter: Includes.subAccounts })
                    .$promise;
            };

            this.select = () => {
                this.updateSelectedCount();
            };

            this.selectAll = () => {
                this.filteredItems
                    .forEach((subAccount) => {
                        subAccount.selected = this.selectAllCheckbox;
                    });
                this.updateSelectedCount();
            };

            this.updateSelectedCount = () => {
                this.selectedCount = _.chain(this.subAccounts).filter((subAccount) => subAccount.selected).size().value();
            };

            this.goToViewSubAccount = (id) => {
                $state.go('root.my-account.sub-accounts.view', { id: id });
            };

            this.deleteFilesBySubAccountsIds = (ids) => {
                return $http({
                    url: `${this.SLS_URI}/files/delete-by-sub-accounts-ids`,
                    method: 'DELETE',
                    data: {
                        subAccountsIds: ids,
                        accountId: this.account.id,
                    },
                });
            };

            this.deleteSubAccountsAssets = (ids) => {
                return Promise
                    .all([
                        App.destroyAll({ where: { subAccountId: { inq: ids } } }).$promise,
                        AppTemplate.destroyAll({ where: { subAccountId: { inq: ids } } }).$promise,
                        Display.destroyAll({ where: { subAccountId: { inq: ids } } }).$promise,
                        Group.destroyAll({ where: { subAccountId: { inq: ids } } }).$promise,
                        Playlist.destroyAll({ where: { subAccountId: { inq: ids } } }).$promise,
                        Integration.destroyAll({ where: { subAccountId: { inq: ids } } }).$promise,
                        this.deleteFilesBySubAccountsIds(ids),
                    ]);
            };

            this.delete = () => {
                $mdDialog.show({
                    locals: {
                        title: 'Are you sure you want to permanently remove all of the selected sub accounts?',
                        confirmationText: 'This will also remove all APPS, DISPLAYS, GROUPS, PLAYLISTS, FILES & INTEGRATIONS from all of the selected sub accounts',
                        confirmText: 'Yes, I am sure',
                        cancelText: 'Cancel',
                    },
                    controller: ($scope, $mdDialog) => {
                        $scope.cancel = () => {
                            $mdDialog.hide();
                        };
                        $scope.confirm = () => {
                            const ids = _.chain(this.subAccounts)
                                .filter({ selected: true })
                                .map((item) => item.id)
                                .value();

                            this.deleteSubAccountsAssets(ids)
                                .then(() => {
                                    return SubAccount.destroyAll({ where: { id: { inq: ids } } }).$promise;
                                })
                                .then(() => {
                                    _.remove(this.subAccounts, (subAccount) => _.indexOf(ids, subAccount.id) >= 0);
                                    this.selectAllCheckbox = false;
                                    Store.setCurrentSubAccountId(null);
                                    $scope.cancel();
                                })
                                .catch((error) => {
                                    $scope.cancel();
                                    console.error(error);
                                    Raven.captureException(error);
                                });

                        };
                    },
                    controllerAs: '$ctrl',
                    bindToController: true,
                    templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                });
            };
        }
        module
            .config(($stateProvider, $translatePartialLoaderProvider) => {
                $stateProvider.state('root.my-account.sub-accounts', {
                    url: '/sub-accounts',
                    data: {
                        pageTitle: 'SUB_ACCOUNTS.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<sub-accounts-component />',
                        },
                    },
                    bodyClass: 'page--accounts--sub-accounts',
                });
            })
            .component('subAccountsComponent', {
                templateUrl: '/js/my-account/sub-accounts/sub-accounts.html',
                controller: SubAccountsCtrl,
            });

    }

)(angular.module('rocket.components'));
